var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 21,
    viewBox: "0 -6 21 21",
    width: 21,
    className: "injected-svg",
    "data-src": "/static/media/volume.c87198cb.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f3a952"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.66233 1.66753c-.13273.14653-.31371.229-.50255.229h-.6728c-.84724 0-1.68846.15532-2.48852.45947-1.52847.58107-2.640776 2.03112-2.895599 3.77485l-.0068505.04687c-.1280141.87599-.1280139 1.76857.0000003 2.64456l.0068502.04687c.254823 1.74375 1.367129 3.19375 2.895599 3.77485.80006.3041 1.64128.4595 2.48852.4595h.6728c.18884 0 .36982.0824.50255.229l.4937.545c1.90227 2.1002 5.17917 1.1068 5.81537-1.7629.6723-3.0327.6723-6.1965 0-9.22917-.6362-2.8697401-3.9131-3.863145-5.81537-1.76297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4036 1.03465c.287-.37512.7985-.425368 1.1423-.112233 1.5207 1.384813 2.4541 3.863153 2.4541 6.577603 0 2.71448-.9334 5.19278-2.4541 6.57758-.3438.3131-.8553.2629-1.1423-.1122-.2871-.3751-.241-.9331.1029-1.2462 1.0651-.9699 1.8714-2.89278 1.8714-5.21918 0-2.32641-.8063-4.24925-1.8714-5.21918-.3439-.31313-.39-.87107-.1029-1.24619z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.3138 4.40489c-.3725-.27137-.8761-.16194-1.1248.24441-.2488.40636-.1485.95577.224 1.22714.4022.293.7208.88524.7208 1.62357 0 .73834-.3186 1.33058-.7208 1.62358-.3725.27137-.4728.82078-.224 1.22711.2487.4064.7523.5158 1.1248.2444.8908-.64885 1.442-1.81708 1.442-3.09509 0-1.278-.5512-2.44623-1.442-3.09512z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMax);
export default __webpack_public_path__ + "static/media/volume-max.8a075981779a9be0410c012e4c65fd9d.svg";
export { ForwardRef as ReactComponent };